import PackageGalleryItemEdit from './PackageGalleryItemEdit'
import PackageGalleryItemList from './PackageGalleryItemList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: PackageGalleryItemList,
    edit: PackageGalleryItemEdit
}
